import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { routes } from '../constants';

import {
	CmsTemplatePage,
	HomePage,
	ProductCategoryPage,
	ProductOverviewPage,
	DocumentOverviewPage,
	ProjectsOverviewPage,
	FaqOverviewPage,
	FaqSectionPage,
	UsersOverviewPage,
	ReferenceOverviewPage,
	AccessoiresOverviewPage,
	PoUploadPage,
	CreateProductPage,
	CreateAccessoiresPage,
	CreateDocumentPage,
	CreateProjectPage,
	CreateReferencePage,
	CreateUserPage,
	CreateFaqPage,
} from '../CMS';
/**
 * this is the router setup.
 */
function CmsRouting() {
	const index = routes.CMS.DEFAULT;
	const cmsRoute = routes.CMS;
	return (
		<CmsTemplatePage>
			<Switch>
				{/* edit routes */}
				<Route path={`${index}${cmsRoute.CREATE_USERS}/:slug`} component={CreateUserPage} />
				<Route path={`${index}${cmsRoute.CREATE_REFERENCE}/:slug`} component={CreateReferencePage} />
				<Route path={`${index}${cmsRoute.CREATE_PROJECTS}/:slug`} component={CreateProjectPage} />
				<Route path={`${index}${cmsRoute.CREATE_DOCUMENTS}/:slug`} component={CreateDocumentPage} />
				<Route path={`${index}${cmsRoute.CREATE_ACCESSOIRES}/:slug`} component={CreateAccessoiresPage} />
				<Route path={`${index}${cmsRoute.CREATE_PRODUCT}/:slug`} component={CreateProductPage} />
				<Route path={`${index}${cmsRoute.CREATE_FAQ_SECTION}/:slug/create/:faqItemId?`} component={CreateFaqPage} />
				<Route path={`${index}${cmsRoute.CREATE_FAQ_SECTION}/:slug`} component={FaqSectionPage} />
				{/* create routes */}
				<Route path={`${index}${cmsRoute.CREATE_USERS}`} component={CreateUserPage} />
				<Route path={`${index}${cmsRoute.CREATE_REFERENCE}`} component={CreateReferencePage} />
				<Route path={`${index}${cmsRoute.CREATE_PROJECTS}`} component={CreateProjectPage} />
				<Route path={`${index}${cmsRoute.CREATE_DOCUMENTS}`} component={CreateDocumentPage} />
				<Route path={`${index}${cmsRoute.CREATE_ACCESSOIRES}`} component={CreateAccessoiresPage} />
				<Route path={`${index}${cmsRoute.CREATE_PRODUCT}`} component={CreateProductPage} />
				<Route path={`${index}${cmsRoute.CREATE_FAQ_Question}`} component={CreateFaqPage} />
				<Route path={`${index}${cmsRoute.CREATE_FAQ_SECTION}`} component={FaqSectionPage} />
				{/* normal routes */}
				<Route path={`${index}${cmsRoute.PO}`} component={PoUploadPage} />
				<Route path={`${index}${cmsRoute.PRODUCTS_OVERVIEW}`} component={ProductOverviewPage} />
				<Route path={`${index}${cmsRoute.PRODUCTS}`} component={ProductCategoryPage} />
				<Route path={`${index}${cmsRoute.ACCESSOIRES}`} component={AccessoiresOverviewPage} />
				<Route path={`${index}${cmsRoute.REFERENCE}`} component={ReferenceOverviewPage} />
				<Route path={`${index}${cmsRoute.USERS}`} component={UsersOverviewPage} />
				<Route path={`${index}${cmsRoute.FAQ}`} component={FaqOverviewPage} />
				<Route path={`${index}${cmsRoute.PROJECTS}`} component={ProjectsOverviewPage} />
				<Route path={`${index}${cmsRoute.DOCUMENTS}`} component={DocumentOverviewPage} />
				<Route path={index} component={HomePage} />
				<Route render={() => <Redirect to="" />} />
			</Switch>
		</CmsTemplatePage>
	);
}
export default withRouter(CmsRouting);



// WEBPACK FOOTER //
// ./src/router/cms.routing.js